import PaymentFallback from '@/components/PaymentFallback'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: PaymentFallback
	}

	let page = vuewidget(dom, options)
	return page
}
